const TheExportIndexPage = () =>
  import('@/views/export/TheExportIndexPage.vue')

export const exportSubPages = [
  {
    path: 'export',
    name: 'export_page_route',
    component: TheExportIndexPage,
    children: [
      {
        path: 'new',
        name: 'export_new_route',
        component: TheExportIndexPage
      },
      {
        path: ':id',
        name: 'export_detail_route',
        component: TheExportIndexPage
      }
    ]
  }
]